import { Box, Fade, Modal } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import React from "react";
import "./styles.scss";

interface DiscardChangesModalProps {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  confirmAction: () => void;
}

const DiscardChangesModal: React.FC<DiscardChangesModalProps> = ({
  openModal,
  setOpenModal,
  confirmAction,
}) => {
  return (
    <Modal
      open={openModal}
      onClose={() => setOpenModal(false)}
      closeAfterTransition
      aria-labelledby="discard-modal-title"
      aria-describedby="discard-modal-description"
      sx={modalSx}
    >
      <Fade in={openModal}>
        <Box className="discardModal">
          <span className="discardModal__icon">
            <WarningAmberRoundedIcon sx={{ fontSize: 26 }} />
          </span>
          <h2 id="discard-modal-title" className="discardModal__title">
            Do you want to leave?
          </h2>
          <p id="discard-modal-description" className="discardModal__text">
            If you leave, you&apos;ll lose all the data entered in the creation
            panel.
          </p>
          <div className="discardModal__actions">
            <button
              className="discardModal__cancelBtn"
              onClick={() => setOpenModal(false)}
            >
              Cancel
            </button>
            <button className="discardModal__leaveBtn" onClick={confirmAction}>
              Leave
            </button>
          </div>
        </Box>
      </Fade>
    </Modal>
  );
};

export default DiscardChangesModal;

const modalSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backdropFilter: "blur(6px)",
};
